<template>
  <div>
      <h1 style="display: none">Green Solutions y Enel promoviendo los certificados de Energía Renovable</h1>
      <div class="md-layout md-head-water head-enel" style="" >
        <div class="md-layout-item md-small-size-100 mt-2" >
            <h1 class="calcHead head-sellos" style="margin-bottom: 2px !important; margin-top: 15px !important;color: #1f538b;"> PROGRAMA DE CERTIFICADOS </h1>
            <h1 class="calcHead head-sellos" style="margin-top: 2px !important; color: #1f995b;">DE ENERGÍA RENOVABLE</h1>
        </div>
        <div class="md-layout-item right-side-head md-small-size-100 md-size-40 mt-2" style="position: relative;">
            <img src="@/assets/sello_enel.png" alt="Sello Enel"  srcset="" class="head-right-image-seil" >
        </div>
      </div>
      <div style="background-color:#1f538c; text-align: justify; padding-bottom: 4rem;">
          <div class="huella-detail md-layout" style="background-color:#1f538c">
              <div class="md-layout-item md-size-65 md-small-size-100">
                  <p>El programa de certificados de energía renovable no convencional para consumidor final tiene como objetivo dar la oportunidad a clientes a que tengan la opción de elegir operar con energía 100% renovable. Este es un servicio que hasta el día de hoy se encontraba restringido exclusivamente al segmento de generadoras, pero el cual, mediante esta iniciativa, queda de libre acceso a cualquier tipo de empresa. </p>
              </div>
              <div class="md-layout-item"></div>
          </div>
      </div>
      <div class="esquema">
          <h1 class="mt-2">El siguiente esquema muestra los 4 pasos para alcanzar la certificacón de energía renovable</h1>
          
          <div class="md-layout mt-4 schema-side">
            <div class="md-layout-item md-small-size-100" >
                <p style="text-align: center;">Definición del Centro de consumo</p>
                <img src="@/assets/one_eschema.png" alt="Primer Esquema" srcset="">
            </div>
            <div class="md-layout-item md-small-size-100">
                <p style="text-align: center;">Contabilización de Energía Eléctrica</p>
                <img src="@/assets/two_schema.png" alt="Segundo Esquema" srcset="">
            </div>
            <div class="md-layout-item md-small-size-100">
                <p style="text-align: center;">Certificados de ERNC y Validación de GS</p>
                <img src="@/assets/thre_schema.png" alt="Tercer Esquema" srcset="">
            </div>  
            <div class="md-layout-item md-small-size-100">
                <p style="text-align: center;">Sello</p>
                <img src="@/assets/four_schema.png" alt="Cuarto Esquema" style="margin-left: -1.5em" srcset="">
            </div>
          </div>

          
            <div class="md-layout md-alignment-top-center years-item mt-4">
                <div class="md-layout-item md-small-size-50">
                    <a href="/descargar/PROGRAMA_SELLO_VERDE_2022.pdf" download="reporte" style="color: #707070"> 
                        <span class="circle" style="padding: 1rem 0.5rem 0rem 0.5rem">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 477.827 477.827" style="enable-background:new 0 0 477.827 477.827; width: 65%" xml:space="preserve">
                            <g>
                                <g>
                                    <path fill="white" d="M441.537,160.625c1.489-7.981,2.243-16.082,2.253-24.201C443.699,61.019,382.498-0.035,307.093,0.056
                                        c-57.402,0.069-108.63,36.034-128.194,89.999c-35.029-13.944-74.73,3.148-88.675,38.177c-1.207,3.032-2.195,6.146-2.956,9.319
                                        c-55.932,8.365-94.492,60.488-86.127,116.42c7.502,50.163,50.596,87.275,101.316,87.254h85.333
                                        c9.426,0,17.067-7.641,17.067-17.067c0-9.426-7.641-17.067-17.067-17.067h-85.333c-37.703,0-68.267-30.564-68.267-68.267
                                        s30.564-68.267,68.267-68.267c9.426,0,17.067-7.641,17.067-17.067c0.031-18.851,15.338-34.108,34.189-34.077
                                        c8.915,0.015,17.471,3.517,23.837,9.757c6.713,6.616,17.519,6.537,24.135-0.176c2.484-2.521,4.123-5.751,4.69-9.245
                                        c9.264-55.733,61.954-93.403,117.687-84.139c55.733,9.264,93.403,61.954,84.139,117.687c-0.552,3.323-1.269,6.617-2.146,9.869
                                        c-1.962,7.124,0.883,14.701,7.049,18.773c31.416,20.845,39.985,63.212,19.139,94.628c-12.617,19.015-33.9,30.468-56.72,30.522
                                        h-51.2c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h51.2
                                        c56.554-0.053,102.357-45.943,102.303-102.497C477.798,208.625,464.526,180.06,441.537,160.625z"/>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path fill="white" class="arrow-bottom"  d="M353.07,363.292c-6.614-6.387-17.099-6.387-23.712,0l-56.235,56.201V170.558c0-9.426-7.641-17.067-17.067-17.067
                                        c-9.426,0-17.067,7.641-17.067,17.067v248.934l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                        c-6.388,6.614-6.388,17.099,0,23.713l85.333,85.333c6.656,6.673,17.463,6.687,24.136,0.03c0.01-0.01,0.02-0.02,0.031-0.03
                                        l85.333-85.333C360.038,380.644,359.85,369.84,353.07,363.292z"/>
                                </g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            </svg>
                        </span>
                        <p>2022</p>
                    </a>
                </div>
                <div class="md-layout-item md-small-size-50">
                    <a href="/descargar/PROGRAMA_SELLO_VERDE_2021.pdf" download="reporte" style="color: #707070">
                        <span class="circle" style="padding: 1rem 0.5rem 0rem 0.5rem">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 477.827 477.827" style="enable-background:new 0 0 477.827 477.827; width: 65%" xml:space="preserve">
                            <g>
                                <g>
                                    <path fill="white" d="M441.537,160.625c1.489-7.981,2.243-16.082,2.253-24.201C443.699,61.019,382.498-0.035,307.093,0.056
                                        c-57.402,0.069-108.63,36.034-128.194,89.999c-35.029-13.944-74.73,3.148-88.675,38.177c-1.207,3.032-2.195,6.146-2.956,9.319
                                        c-55.932,8.365-94.492,60.488-86.127,116.42c7.502,50.163,50.596,87.275,101.316,87.254h85.333
                                        c9.426,0,17.067-7.641,17.067-17.067c0-9.426-7.641-17.067-17.067-17.067h-85.333c-37.703,0-68.267-30.564-68.267-68.267
                                        s30.564-68.267,68.267-68.267c9.426,0,17.067-7.641,17.067-17.067c0.031-18.851,15.338-34.108,34.189-34.077
                                        c8.915,0.015,17.471,3.517,23.837,9.757c6.713,6.616,17.519,6.537,24.135-0.176c2.484-2.521,4.123-5.751,4.69-9.245
                                        c9.264-55.733,61.954-93.403,117.687-84.139c55.733,9.264,93.403,61.954,84.139,117.687c-0.552,3.323-1.269,6.617-2.146,9.869
                                        c-1.962,7.124,0.883,14.701,7.049,18.773c31.416,20.845,39.985,63.212,19.139,94.628c-12.617,19.015-33.9,30.468-56.72,30.522
                                        h-51.2c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h51.2
                                        c56.554-0.053,102.357-45.943,102.303-102.497C477.798,208.625,464.526,180.06,441.537,160.625z"/>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path fill="white" class="arrow-bottom"  d="M353.07,363.292c-6.614-6.387-17.099-6.387-23.712,0l-56.235,56.201V170.558c0-9.426-7.641-17.067-17.067-17.067
                                        c-9.426,0-17.067,7.641-17.067,17.067v248.934l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                        c-6.388,6.614-6.388,17.099,0,23.713l85.333,85.333c6.656,6.673,17.463,6.687,24.136,0.03c0.01-0.01,0.02-0.02,0.031-0.03
                                        l85.333-85.333C360.038,380.644,359.85,369.84,353.07,363.292z"/>
                                </g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            </svg>
                        </span>
                        <p>2021</p>
                    </a>
                </div>
                <div class="md-layout-item md-small-size-50">
                    <a href="/descargar/inventario_enel_2019.pdf" download="reporte" style="color: #707070">
                        <span class="circle" style="padding: 1rem 0.5rem 0rem 0.5rem">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 477.827 477.827" style="enable-background:new 0 0 477.827 477.827; width: 65%" xml:space="preserve">
                            <g>
                                <g>
                                    <path fill="white" d="M441.537,160.625c1.489-7.981,2.243-16.082,2.253-24.201C443.699,61.019,382.498-0.035,307.093,0.056
                                        c-57.402,0.069-108.63,36.034-128.194,89.999c-35.029-13.944-74.73,3.148-88.675,38.177c-1.207,3.032-2.195,6.146-2.956,9.319
                                        c-55.932,8.365-94.492,60.488-86.127,116.42c7.502,50.163,50.596,87.275,101.316,87.254h85.333
                                        c9.426,0,17.067-7.641,17.067-17.067c0-9.426-7.641-17.067-17.067-17.067h-85.333c-37.703,0-68.267-30.564-68.267-68.267
                                        s30.564-68.267,68.267-68.267c9.426,0,17.067-7.641,17.067-17.067c0.031-18.851,15.338-34.108,34.189-34.077
                                        c8.915,0.015,17.471,3.517,23.837,9.757c6.713,6.616,17.519,6.537,24.135-0.176c2.484-2.521,4.123-5.751,4.69-9.245
                                        c9.264-55.733,61.954-93.403,117.687-84.139c55.733,9.264,93.403,61.954,84.139,117.687c-0.552,3.323-1.269,6.617-2.146,9.869
                                        c-1.962,7.124,0.883,14.701,7.049,18.773c31.416,20.845,39.985,63.212,19.139,94.628c-12.617,19.015-33.9,30.468-56.72,30.522
                                        h-51.2c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h51.2
                                        c56.554-0.053,102.357-45.943,102.303-102.497C477.798,208.625,464.526,180.06,441.537,160.625z"/>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path fill="white" class="arrow-bottom"  d="M353.07,363.292c-6.614-6.387-17.099-6.387-23.712,0l-56.235,56.201V170.558c0-9.426-7.641-17.067-17.067-17.067
                                        c-9.426,0-17.067,7.641-17.067,17.067v248.934l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                        c-6.388,6.614-6.388,17.099,0,23.713l85.333,85.333c6.656,6.673,17.463,6.687,24.136,0.03c0.01-0.01,0.02-0.02,0.031-0.03
                                        l85.333-85.333C360.038,380.644,359.85,369.84,353.07,363.292z"/>
                                </g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            </svg>
                        </span>
                        <p>2019</p>
                    </a>
                </div>
                <div class="md-layout-item md-small-size-50">
                    <a href="/descargar/ernc-2018.pdf" download="reporte" style="color: #707070">
                        <span class="circle" style="padding: 1rem 0.5rem 0rem 0.5rem">
                            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"  xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                viewBox="0 0 477.827 477.827" style="enable-background:new 0 0 477.827 477.827; width: 65%" xml:space="preserve">
                            <g>
                                <g>
                                    <path fill="white" d="M441.537,160.625c1.489-7.981,2.243-16.082,2.253-24.201C443.699,61.019,382.498-0.035,307.093,0.056
                                        c-57.402,0.069-108.63,36.034-128.194,89.999c-35.029-13.944-74.73,3.148-88.675,38.177c-1.207,3.032-2.195,6.146-2.956,9.319
                                        c-55.932,8.365-94.492,60.488-86.127,116.42c7.502,50.163,50.596,87.275,101.316,87.254h85.333
                                        c9.426,0,17.067-7.641,17.067-17.067c0-9.426-7.641-17.067-17.067-17.067h-85.333c-37.703,0-68.267-30.564-68.267-68.267
                                        s30.564-68.267,68.267-68.267c9.426,0,17.067-7.641,17.067-17.067c0.031-18.851,15.338-34.108,34.189-34.077
                                        c8.915,0.015,17.471,3.517,23.837,9.757c6.713,6.616,17.519,6.537,24.135-0.176c2.484-2.521,4.123-5.751,4.69-9.245
                                        c9.264-55.733,61.954-93.403,117.687-84.139c55.733,9.264,93.403,61.954,84.139,117.687c-0.552,3.323-1.269,6.617-2.146,9.869
                                        c-1.962,7.124,0.883,14.701,7.049,18.773c31.416,20.845,39.985,63.212,19.139,94.628c-12.617,19.015-33.9,30.468-56.72,30.522
                                        h-51.2c-9.426,0-17.067,7.641-17.067,17.067c0,9.426,7.641,17.067,17.067,17.067h51.2
                                        c56.554-0.053,102.357-45.943,102.303-102.497C477.798,208.625,464.526,180.06,441.537,160.625z"/>
                                </g>
                            </g>
                            <g>
                                <g>
                                    <path fill="white" class="arrow-bottom"  d="M353.07,363.292c-6.614-6.387-17.099-6.387-23.712,0l-56.235,56.201V170.558c0-9.426-7.641-17.067-17.067-17.067
                                        c-9.426,0-17.067,7.641-17.067,17.067v248.934l-56.201-56.201c-6.78-6.548-17.584-6.36-24.132,0.419
                                        c-6.388,6.614-6.388,17.099,0,23.713l85.333,85.333c6.656,6.673,17.463,6.687,24.136,0.03c0.01-0.01,0.02-0.02,0.031-0.03
                                        l85.333-85.333C360.038,380.644,359.85,369.84,353.07,363.292z"/>
                                </g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            <g>
                            </g>
                            </svg>
                        </span>
                        <p>2018</p>
                    </a>
                </div>
            </div>
      </div>
  </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Programa de certificados de Energia Renovable de Enel',
        meta: [
            { name: 'description', content: 'Programa de certificados de Energía Renovable exclusivos de Enel | Contribuye a un futuro más sostenible y reduce tu huella de carbono.' }
        ]
    },
    methods: {
        async download () {
        
        }
    }

}
</script>

<style>
.circle {
    display: inline-block;
}
.head-enel {
    padding-left: 5rem !important;
}
.schema-side {
    width: 95%;
    margin: auto;
    margin-left: 5vw;
    margin-top: 5vw;
}
.esquema {
    padding: 5vw 0vw 5vw 0vw;
    background-color: #f2f2f2;
}
.esquema h1 {
    font-size: 1.6vw;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: -0.66px;
    text-align: center;
    font-weight: bold;
}
.esquema p {
    font-size: 1.6vw;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: -0.66px;
    text-align: center;
}   
.years-item {
    text-align: center;
    padding: 3vw 10vw 0vw 10vw; 
}
.years-item span.circle {
    margin: auto;
    text-align: center;
}
.years-item p {
    text-align: center !important;
    align-self: center;
    font-size: 1.4vw;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: -0.66px;
}
.md-layout-item a{
    text-decoration: none !important;
}


/* Arrow & Hover Animation */
 #more-arrows {
	width: 75px;
    height: 65px;
    animation-name: arrowDown;
}

 .arrow-bottom {
	animation-name: arrowdown;
    animation-duration: 1.5s; 
    animation-timing-function: ease-out; 
    animation-delay: 0;
    animation-iteration-count: infinite;
    animation-fill-mode: none;
    animation-play-state: running;
}
 #more-arrows:hover polygon.arrow-top {
	 transform: translateY(18px);
}
 polygon {
	 fill: #fff;
	 transition: all 0.2s ease-out;
}
 polygon.arrow-middle {
	 opacity: 0.75;
}
 polygon.arrow-top {
	 opacity: 0.5;
}

@keyframes arrowdown {
    0% {
        transform: translateY(-20px);
    }
    25%{
        transform: translateY(-10px);
    }
    50% {
        transform: translateY(-0px);
    }
    75%{
        transform: translateY(10px);
    }
    100% {
        transform: translateY(20px);
    }
}
</style>
